import { Column, TableContainer } from "./Components";


export default function TableCol({children, onClick}){
    return (
        <Column onClick={onClick}>
            {children}
        </Column>
    )
}